import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import ModernNavigation from '@/components/ModernNavigation';
import BookingSearchModule from '@/components/BookingSearchModule';
import TrustIndicators from '@/components/TrustIndicators';
import Footer from '@/components/Footer';
import FloatingFAQ from '@/components/FloatingFAQ';
import StickyReservationCTA from '@/components/StickyReservationCTA';
import Hero from '@/components/Hero';
import UniformCard from '@/components/UniformCard';
import { ScrollReveal } from '@/components/ScrollReveal';
import { Bike, Users, Building2, Heart, Shield, MapPin, ArrowRight, CheckCircle, Truck, Tent, User, Recycle, Handshake, Target, Briefcase, LogIn, Wrench, Star, ExternalLink, Award, Clock, Zap } from 'lucide-react';
import { IMAGES } from '@/assets/images';
const Particuliers = () => {
  return <div className="min-h-screen bg-background">
      <ModernNavigation />
      
      {/* 1. HERO – CLARITY & BEAUTY (B2C FIRST) */}
      <Hero badge={{
      text: "Location de vélos",
      icon: "🚴‍♂️"
    }} title="Louez votre vélo" titleHighlight="pour vos vacances" description="Le service vélo de confiance recommandé par votre lieu de séjour. Simple, fiable et proche de vous." primaryCTA={{
      text: "Réserver un vélo",
      href: "/reserver"
    }} secondaryCTA={{
      text: "Voir les vélos reconditionnés",
      href: "/velos-occasion"
    }} image={{
      src: "https://static-us-img.skywork.ai/prod/user/head_picture/2010994162885103616_logo hirondelles fond transparent.png?image_process=quality,q_90/resize,w_1280/format,webp",
      alt: "Les Hirondelles - Location de vélos"
    }} backgroundVariant="default" />

      {/* Booking Search Module */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <BookingSearchModule />
      </div>

      {/* Trust Indicators */}
      <TrustIndicators />

      {/* 2. NOS SERVICES VÉLO */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <ScrollReveal className="text-center mb-16">
            <h2 className="text-3xl font-bold text-slate-900 mb-6">
              Comment louer votre vélo ?
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
              Choisissez votre mode de location et accédez directement au service adapté.
            </p>
          </ScrollReveal>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <ScrollReveal delay={100}>
              <Card className="group border-0 shadow-lg hover:shadow-xl transition-all duration-300 bg-white overflow-hidden h-full">
                <div className="relative h-48 overflow-hidden">
                  <img src={IMAGES.CAMPING_SERVICE_ILLUSTRATION_20260305_173524_89} alt="Location dans votre camping" className="w-full h-full object-contain p-4 group-hover:scale-105 transition-transform duration-300" />
                </div>
                <CardContent className="p-6">
                  <div className="flex items-center mb-3">
                    <div className="w-10 h-10 bg-emerald-100 rounded-full flex items-center justify-center mr-3">
                      <Tent className="w-5 h-5 text-emerald-600" />
                    </div>
                    <h3 className="font-semibold text-slate-900">Location dans votre camping</h3>
                  </div>
                  <p className="text-slate-600 text-sm mb-4 leading-relaxed">
                    Votre camping propose nos vélos ? Réservez directement sur place ou en ligne.
                  </p>
                  <Link to="/reserver">
                    <Button variant="outline" className="w-full group-hover:bg-emerald-50 group-hover:border-emerald-200 transition-colors">
                      Réserver dans mon camping
                      <ArrowRight className="w-4 h-4 ml-2" />
                    </Button>
                  </Link>
                </CardContent>
              </Card>
            </ScrollReveal>

            <ScrollReveal delay={200}>
              <Card className="group border-0 shadow-lg hover:shadow-xl transition-all duration-300 bg-gradient-to-br from-emerald-50 to-white overflow-hidden h-full relative">
                {/* Seasonal Badge */}
                <div className="absolute top-4 right-4 z-10">
                  <Badge className="bg-emerald-600 text-white text-xs px-3 py-1">
                    Juillet - Août
                  </Badge>
                </div>
                <div className="relative h-48 overflow-hidden">
                  <img src={IMAGES.DELIVERY_SERVICE_ILLUSTRATION_20260305_173523_90} alt="Livraison de vélos" className="w-full h-full object-contain p-4 group-hover:scale-105 transition-transform duration-300" />
                </div>
                <CardContent className="p-6">
                  <div className="flex items-center mb-3">
                    <div className="w-10 h-10 bg-emerald-100 rounded-full flex items-center justify-center mr-3">
                      <Truck className="w-5 h-5 text-emerald-600" />
                    </div>
                    <h3 className="font-semibold text-slate-900">Livraison de vélos</h3>
                  </div>
                  <p className="text-sm text-emerald-700 font-medium mb-2">
                    Disponible en juillet et août
                  </p>
                  <p className="text-slate-600 text-sm mb-4 leading-relaxed">
                    Livraison sur la côte atlantique. Nous apportons les vélos à votre hébergement.
                  </p>
                  <Link to="/reserver">
                    <Button className="w-full bg-emerald-600 hover:bg-emerald-700 text-white transition-colors">
                      Réserver
                      <ArrowRight className="w-4 h-4 ml-2" />
                    </Button>
                  </Link>
                </CardContent>
              </Card>
            </ScrollReveal>

            <ScrollReveal delay={300}>
              <Card className="group border-0 shadow-lg hover:shadow-xl transition-all duration-300 bg-white overflow-hidden h-full">
                <div className="relative h-48 overflow-hidden">
                  <img src={IMAGES.GROUP_SERVICE_ILLUSTRATION_20260305_173523_91} alt="Groupes & séminaires" className="w-full h-full object-contain p-4 group-hover:scale-105 transition-transform duration-300" />
                </div>
                <CardContent className="p-6">
                  <div className="flex items-center mb-3">
                    <div className="w-10 h-10 bg-emerald-100 rounded-full flex items-center justify-center mr-3">
                      <Users className="w-5 h-5 text-emerald-600" />
                    </div>
                    <h3 className="font-semibold text-slate-900">Groupes & sorties</h3>
                  </div>
                  <p className="text-slate-600 text-sm mb-4 leading-relaxed">
                    Sorties de groupe, team building ou événements familiaux. Nous organisons votre balade.
                  </p>
                  <Link to="/demande-groupe">
                    <Button variant="outline" className="w-full group-hover:bg-emerald-50 group-hover:border-emerald-200 transition-colors">
                      Faire une demande
                      <ArrowRight className="w-4 h-4 ml-2" />
                    </Button>
                  </Link>
                </CardContent>
              </Card>
            </ScrollReveal>

            <ScrollReveal delay={400}>
              <Card className="group border-0 shadow-lg hover:shadow-xl transition-all duration-300 bg-white overflow-hidden h-full">
                <div className="relative h-48 overflow-hidden">
                  <img src={IMAGES.REFURBISHED_SERVICE_ILLUSTRATION_20260305_173523_92} alt="Vélos reconditionnés" className="w-full h-full object-contain p-4 group-hover:scale-105 transition-transform duration-300" />
                </div>
                <CardContent className="p-6">
                  <div className="flex items-center mb-3">
                    <div className="w-10 h-10 bg-emerald-100 rounded-full flex items-center justify-center mr-3">
                      <Recycle className="w-5 h-5 text-emerald-600" />
                    </div>
                    <h3 className="font-semibold text-slate-900">Vélos reconditionnés</h3>
                  </div>
                  <p className="text-slate-600 text-sm mb-4 leading-relaxed">
                    Achetez un vélo de qualité à prix réduit. Entièrement révisés et garantis.
                  </p>
                  <Link to="/velos-occasion">
                    <Button variant="outline" className="w-full group-hover:bg-emerald-50 group-hover:border-emerald-200 transition-colors">
                      Voir les vélos disponibles
                      <ArrowRight className="w-4 h-4 ml-2" />
                    </Button>
                  </Link>
                </CardContent>
              </Card>
            </ScrollReveal>
          </div>
        </div>
      </section>

      {/* 3. TARIFS & CONDITIONS */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <ScrollReveal>
              <div>
                <h2 className="text-3xl font-bold text-slate-900 mb-6">
                  Tarifs & conditions
                </h2>
                <p className="text-lg text-slate-600 mb-8 leading-relaxed">
                  Des offres claires, adaptées à la durée et à l'usage. Pas de surprise, que de la transparence.
                </p>
                <div className="space-y-4 mb-8">
                  <div className="flex items-center">
                    <CheckCircle className="w-5 h-5 text-emerald-600 mr-3 flex-shrink-0" />
                    <span className="text-slate-700">Tarifs dégressifs selon la durée</span>
                  </div>
                  <div className="flex items-center">
                    <CheckCircle className="w-5 h-5 text-emerald-600 mr-3 flex-shrink-0" />
                    <span className="text-slate-700">Assurance et casque inclus</span>
                  </div>
                  <div className="flex items-center">
                    <CheckCircle className="w-5 h-5 text-emerald-600 mr-3 flex-shrink-0" />
                    <span className="text-slate-700">Maintenance préventive</span>
                  </div>
                  <div className="flex items-center">
                    <CheckCircle className="w-5 h-5 text-emerald-600 mr-3 flex-shrink-0" />
                    <span className="text-slate-700">Support technique 7j/7</span>
                  </div>
                </div>
                <Link to="/tarifs">
                  <Button size="lg" className="bg-emerald-600 hover:bg-emerald-700">
                    Voir tous les tarifs
                    <ArrowRight className="w-5 h-5 ml-2" />
                  </Button>
                </Link>
              </div>
            </ScrollReveal>
            
            <ScrollReveal delay={200}>
              <div className="relative">
                <img src={IMAGES.ILLUSTRATION_VELOS_TARIFS_20260211_112726_16} alt="Tarifs vélos" className="w-full h-auto rounded-2xl shadow-lg" />
              </div>
            </ScrollReveal>
          </div>
        </div>
      </section>

      {/* 4. VÉLOS RECONDITIONNÉS */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <ScrollReveal>
              <div className="relative">
                <img src={IMAGES.VELO_RECONDITIONNE_1} alt="Vélos reconditionnés" className="w-full h-auto rounded-2xl shadow-lg" />
              </div>
            </ScrollReveal>
            
            <ScrollReveal delay={200}>
              <div>
                <h2 className="text-3xl font-bold text-slate-900 mb-6">
                  Vélos reconditionnés
                </h2>
                <p className="text-lg text-slate-600 mb-8 leading-relaxed">
                  Nos vélos de location trouvent une seconde vie. Remis à neuf par nos soins, ils gardent toute leur qualité pour vos balades quotidiennes.
                </p>
                <div className="space-y-4 mb-8">
                  <div className="flex items-center">
                    <CheckCircle className="w-5 h-5 text-emerald-600 mr-3 flex-shrink-0" />
                    <span className="text-slate-700">Révision complète par nos mécaniciens</span>
                  </div>
                  <div className="flex items-center">
                    <CheckCircle className="w-5 h-5 text-emerald-600 mr-3 flex-shrink-0" />
                    <span className="text-slate-700">Garantie 6 mois pièces et main d'œuvre</span>
                  </div>
                  <div className="flex items-center">
                    <CheckCircle className="w-5 h-5 text-emerald-600 mr-3 flex-shrink-0" />
                    <span className="text-slate-700">Prix jusqu'à 50% moins cher</span>
                  </div>
                  <div className="flex items-center">
                    <CheckCircle className="w-5 h-5 text-emerald-600 mr-3 flex-shrink-0" />
                    <span className="text-slate-700">Livraison possible sur la côte</span>
                  </div>
                </div>
                <Link to="/velos-occasion">
                  <Button size="lg" className="bg-emerald-600 hover:bg-emerald-700">
                    Découvrir nos vélos
                    <ArrowRight className="w-5 h-5 ml-2" />
                  </Button>
                </Link>
              </div>
            </ScrollReveal>
          </div>
        </div>
      </section>

      {/* 5. INSPIRATION BALADES */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <ScrollReveal className="text-center mb-16">
            <h2 className="text-3xl font-bold text-slate-900 mb-6">
              Besoin d'inspiration pour vos balades ?
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
              Île de Ré, Montalivet, Landes… Découvrez les plus beaux parcours de la côte atlantique.
            </p>
          </ScrollReveal>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            <ScrollReveal delay={100}>
              <Card className="group border-0 shadow-lg hover:shadow-xl transition-all duration-300 bg-white overflow-hidden">
                <div className="relative h-48 overflow-hidden">
                  <img src={IMAGES.CAMPING_VELO_1} alt="Île de Ré" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                  <div className="absolute bottom-4 left-4 text-white">
                    <h3 className="font-semibold text-lg">Île de Ré</h3>
                    <p className="text-sm opacity-90">Pistes cyclables & villages</p>
                  </div>
                </div>
              </Card>
            </ScrollReveal>

            <ScrollReveal delay={200}>
              <Card className="group border-0 shadow-lg hover:shadow-xl transition-all duration-300 bg-white overflow-hidden">
                <div className="relative h-48 overflow-hidden">
                  <img src={IMAGES.CAMPING_VELO_2} alt="Montalivet" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                  <div className="absolute bottom-4 left-4 text-white">
                    <h3 className="font-semibold text-lg">Montalivet</h3>
                    <p className="text-sm opacity-90">Plages & forêts de pins</p>
                  </div>
                </div>
              </Card>
            </ScrollReveal>

            <ScrollReveal delay={300}>
              <Card className="group border-0 shadow-lg hover:shadow-xl transition-all duration-300 bg-white overflow-hidden">
                <div className="relative h-48 overflow-hidden">
                  <img src={IMAGES.CAMPING_VELO_3} alt="Lacanau" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                  <div className="absolute bottom-4 left-4 text-white">
                    <h3 className="font-semibold text-lg">Lacanau</h3>
                    <p className="text-sm opacity-90">Lacs & océan</p>
                  </div>
                </div>
              </Card>
            </ScrollReveal>
          </div>

          <ScrollReveal className="text-center">
            <Link to="/balades">
              <Button size="lg" variant="outline" className="border-emerald-600 text-emerald-600 hover:bg-emerald-50">
                Voir tous les parcours
                <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
            </Link>
          </ScrollReveal>
        </div>
      </section>

      {/* 6. AVIS GOOGLE */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <ScrollReveal>
            <div className="flex items-center justify-center mb-4">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-yellow-400 fill-current" />)}
            </div>
            <p className="text-lg text-slate-600 mb-6">
              Note moyenne : <span className="font-semibold text-slate-900">4,7 / 5</span> sur Google
            </p>
            <a href="https://share.google/fwo6607fXVNneBIbl" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-emerald-600 hover:text-emerald-700 font-medium">
              Voir les avis
              <ExternalLink className="w-4 h-4 ml-2" />
            </a>
          </ScrollReveal>
        </div>
      </section>

      {/* 7. NOS ZONES DE LOCATION */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <ScrollReveal className="text-center mb-16">
            <h2 className="text-3xl font-bold text-slate-900 mb-6">
              Nos zones de location
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
              Présents sur toute la côte atlantique française, de la Charente-Maritime aux Landes.
            </p>
          </ScrollReveal>
          
          <ScrollReveal delay={200}>
            <div className="relative bg-white rounded-2xl shadow-lg p-8">
              
              <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
                <div className="p-4">
                  <MapPin className="w-6 h-6 text-emerald-600 mx-auto mb-2" />
                  <h4 className="font-semibold text-slate-900">Charente-Maritime</h4>
                  <p className="text-sm text-slate-600">Île de Ré, La Rochelle</p>
                </div>
                <div className="p-4">
                  <MapPin className="w-6 h-6 text-emerald-600 mx-auto mb-2" />
                  <h4 className="font-semibold text-slate-900">Vendée</h4>
                  <p className="text-sm text-slate-600">Les Sables d'Olonne</p>
                </div>
                <div className="p-4">
                  <MapPin className="w-6 h-6 text-emerald-600 mx-auto mb-2" />
                  <h4 className="font-semibold text-slate-900">Gironde</h4>
                  <p className="text-sm text-slate-600">Arcachon, Lacanau</p>
                </div>
                <div className="p-4">
                  <MapPin className="w-6 h-6 text-emerald-600 mx-auto mb-2" />
                  <h4 className="font-semibold text-slate-900">Landes</h4>
                  <p className="text-sm text-slate-600">Montalivet, Soulac</p>
                </div>
              </div>
            </div>
          </ScrollReveal>
        </div>
      </section>

      {/* 8. LES HIRONDELLES, COOPÉRATIVE VÉLO */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <ScrollReveal>
              <div>
                <h2 className="text-3xl font-bold text-slate-900 mb-6">
                  Les Hirondelles, coopérative vélo
                </h2>
                <p className="text-lg text-slate-600 mb-8 leading-relaxed">
                  Une équipe passionnée au service de la mobilité douce sur la côte atlantique
                </p>
                <div className="space-y-6">
                  <div className="flex items-start">
                    <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                      <Target className="w-6 h-6 text-emerald-600" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-slate-900 mb-2">Expertise terrain</h3>
                      <p className="text-slate-600">Nous connaissons les besoins réels des vacanciers et des professionnels du tourisme.</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                      <Shield className="w-6 h-6 text-emerald-600" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-slate-900 mb-2">Service de qualité</h3>
                      <p className="text-slate-600">Maintenance, logistique et service client : nous gérons tout pour vos vacances.</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                      <Heart className="w-6 h-6 text-emerald-600" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-slate-900 mb-2">Mobilité accessible</h3>
                      <p className="text-slate-600">Rendre le vélo accessible à tous, partout sur la côte atlantique.</p>
                    </div>
                  </div>
                </div>
              </div>
            </ScrollReveal>
            
            <ScrollReveal delay={200}>
              <div className="relative">
                <img src={IMAGES.CORPORATE_GROUP_CYCLING_20260211_111333_15} alt="Équipe Les Hirondelles" className="w-full h-auto rounded-2xl shadow-lg" />
              </div>
            </ScrollReveal>
          </div>
        </div>
      </section>

      {/* 9. FINAL CTA */}
      <section className="py-20 bg-emerald-600 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <ScrollReveal>
            <h2 className="text-3xl font-bold mb-6">
              Prêt pour votre prochaine balade ?
            </h2>
            <p className="text-xl text-emerald-100 mb-8 leading-relaxed">
              Réservez votre vélo en quelques clics ou contactez-nous pour plus d'informations.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/reserver">
                <Button size="lg" variant="secondary" className="bg-white text-emerald-600 hover:bg-emerald-50">
                  Réserver un vélo
                  <ArrowRight className="w-5 h-5 ml-2" />
                </Button>
              </Link>
              <Link to="/nous-contacter">
                <Button size="lg" variant="outline" className="border-white text-white hover:bg-white hover:text-emerald-600">
                  Nous contacter
                </Button>
              </Link>
            </div>
          </ScrollReveal>
        </div>
      </section>

      <Footer />
      <FloatingFAQ />
      <StickyReservationCTA />
    </div>;
};
export default Particuliers;